import { extractQuickActionsFromText } from "./quickActions";

// Exact selection phrases only. Questions and narrative mentions remain speech.
export function parseHomeworkVoiceSelection(
  raw: string,
  choices: readonly string[],
): string | null {
  if (raw.includes("?")) return null;
  const text = raw.toLowerCase().replace(/[’]/g, "'")
    .replace(/[.!,:;]/g, " ").replace(/\s+/g, " ").trim()
    // Observed transcription of "let's do number ...". Require an explicit
    // number cue so ordinary statements about due dates remain unchanged.
    .replace(/^that's due (?=(?:homework )?number )/, "choose ");
  const match = text.match(
    /^(?:(?:(?:let's|let us)\s+(?:do|choose|select|work\s+on)|i\s+(?:choose|select|pick)|(?:choose|select|pick|do|work\s+on))\s+)?(?:homework\s+)?(?:number\s+)?(\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|thirteen|fourteen|fifteen|sixteen|seventeen|eighteen|nineteen|twenty|won|to|too|tree|for|fore|ate|night|niner)(?:\s+please)?$/,
  );
  if (!match) return null;
  const words = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen", "twenty"];
  const token = match[1];
  const aliases: Record<string, string> = {
    won: "1", to: "2", too: "2", tree: "3", for: "4", fore: "4",
    ate: "8", night: "9", niner: "9",
  };
  const number = aliases[token] ?? (
    /^\d+$/.test(token) ? String(Number(token)) : String(words.indexOf(token))
  );
  return choices.includes(number) ? number : null;
}

// Use the current prompt as well as the one-shot awaitKey. Some list/retry
// responses omit that key even though they still offer homework choices.
export function getHomeworkVoiceChoices(prompt: {
  text?: string;
  intent?: string | null;
  isQAStep?: boolean;
  awaitKey?: string | null;
}): string[] {
  const key = prompt.awaitKey?.trim().toLowerCase();
  if (prompt.isQAStep || (key && key !== "homework_choice")) return [];
  const text = prompt.text ?? "";
  const asksForHomeworkNumber = /\bhomework\b/i.test(text) &&
    /\b(?:say|type|enter|choose|select|pick)\s+(?:(?:a|the|your)\s+)?(?:homework\s+)?number\b/i.test(text);
  if (key !== "homework_choice" && prompt.intent !== "HW_SELECTION" && !asksForHomeworkNumber) {
    return [];
  }
  return extractQuickActionsFromText(text, { awaitKey: prompt.awaitKey })
    .filter((action) => action.group === "HomeworkSelect")
    .map((action) => action.value.trim())
    .filter((value) => /^\d{1,2}$/.test(value));
}
